import { EffectiveDefinition, Features } from '../../models';

export interface WarehousingFeature {
  readonly aggregation: string;
}

export const getWarehousingFeature = (features: Features): WarehousingFeature | undefined => {
  return features.warehousing;
};

// With the initial release of snapshotting/warehousing, we know whether a metric is being snapshotted
// by the presence of the `warehousing` feature, which, for now, will always be { aggregation: "last" }.
// See details here: https://salesforce.quip.com/IE4KAd1EBEvb#temp:C:CFb2250dce89837428184f4d4352
export const isBeingWarehoused = (features?: Features): boolean => {
  return !!features && features.warehousing !== undefined;
};

export const definitionWithWarehousing = (definition: EffectiveDefinition): EffectiveDefinition => {
  const newFeatures = { ...definition.features, warehousing: { aggregation: 'last' } };
  return { ...definition, features: newFeatures };
};
